import React from 'react';

export const warningEnum = 1;
export const errorEnum = 2;

export const noProperty = "np";

// export function getErrors(validationSummary, properties) {

//     const issues = getIssues(validationSummary, properties);
//     return issues[warningEnum] ? issues[warningEnum] : [];
// }

// export function geErrors(validationSummary, properties) {

//     const issues = getIssues(validationSummary, properties);
//     return issues[errorEnum] ? issues[errorEnum] : [];
// }

// export function getIssues(validationSummary, properties) {
export function getWarnings(validationSummary, properties) {
    return getSummaryMessage(validationSummary, properties, 1);
}

export function getErrors(validationSummary, properties) {
    return getSummaryMessage(validationSummary, properties, 2);
}

function getSummaryMessage(validationSummary, properties, type) {
    const warnings = [];

    if (validationSummary && !validationSummary.isValid) {
        if (validationSummary.messages) {
            validationSummary.messages.forEach(message => {
                if (message.relatedProperties && message.type === type) {
                    message.relatedProperties.forEach(relatedProperty => {

                        if (properties) {
                            if (Array.isArray(properties)) {
                                properties.forEach(property => {
                                    if (property && (property.id === relatedProperty)) {
                                        warnings.push(message);
                                    }
                                });
                            } else {
                                Object.values(properties).forEach(property => {
                                    if (property.id === relatedProperty) {
                                        warnings.push(message);
                                    }
                                });
                            }
                        } else if (properties === null) {
                            warnings.push(message);
                        }
                    });
                }
            });
        }
    }

    return warnings;
}

export function getIssuesComponent(errors, warnings) {

    if (errors.length > 0) {
        return (
            <div className="error-text">
                {errors.map(issue => issue.description)}
            </div>
        );
    } else if (warnings.length > 0) {
        return (
            <div className="warning-text">
                {warnings.map(issue => issue.description)}
            </div>
        );
    }

    return null;
}

export function getWarningIssues(issueByProperty, properties) {
    return getIssues(issueByProperty, properties, warningEnum);
}

export function getErrorIssues(issueByProperty, properties) {
    return getIssues(issueByProperty, properties, errorEnum);
}

export function getIssues(issueByProperty, properties, type) {

    if (issueByProperty === null
        || issueByProperty === undefined) {

        return [];
    }

    const issues = [];

    (Array.isArray(properties) ? properties : [properties]).forEach(property => {
        if (property && issueByProperty[property.id] && issueByProperty[property.id][type]) {
            issueByProperty[property.id][type].forEach(element => {
                issues.push(element);
            });
        }
    });

    return issues;
}

export function getIssuesByProperty(validationSummary, properties) {

    const issues = {};
    issues[noProperty] = {};
    issues[noProperty][warningEnum] = [];
    issues[noProperty][errorEnum] = [];

    if (validationSummary && validationSummary.messages) {
        validationSummary.messages.forEach(message => {
            if (message.relatedProperties && message.relatedProperties.length > 0) {
                message.relatedProperties.forEach(relatedProperty => {

                    if (!issues[relatedProperty]) {
                        issues[relatedProperty] = {};
                        issues[relatedProperty][warningEnum] = [];
                        issues[relatedProperty][errorEnum] = [];
                    }

                    if (!issues[relatedProperty][message.type]) {
                        issues[relatedProperty][message.type] = [];
                    }

                    issues[relatedProperty][message.type].push(message);
                });
            } else {
                if (!issues[noProperty][message.type]) {
                    issues[noProperty][message.type] = [];
                }

                issues[noProperty][message.type].push(message);
            }
        });
    }

    return issues;
}

export function isValid(validationSummary, property) {
    return getErrors(validationSummary, [property]).length > 0 ? false : true;
}


// {
//     "messages": [
//       {
//         "savedValue": "-3.0000",
//         "type": 1,
//         "msgId": 3,
//         "name": "Lost precision for property.",
//         "description": "The provided property value of \"-3.000\" has lost precision during conversion. The new value is: \"-3.0000\".",
//         "relatedProperties": [
//           16512078
//         ]
//       },
//       {
//         "type": 2,
//         "msgId": 4,
//         "name": "Value is not in min max range of the property",
//         "description": "Value is not in range [0.0000, 279.6191]",
//         "relatedProperties": [
//           16512078
//         ]
//       }
//     ],
//     "isValid": false,
//     "warningCount": 1,
//     "errorCount": 1
//   }